import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import './Widget.scss';

export default class Widget extends Component {
    render() {
        const { variant, left, right } = this.props;

        return (
            <div className={`widget-row ${variant}`}>
                <div className={classNames('widget-half', { 'left': !_.isUndefined(this.props.right) })}>
                    {left}
                </div>
                <div className="widget-half">
                    {right}
                </div>
            </div>
        );
    }
}

Widget.propTypes = {
    variant: PropTypes.oneOf([
        'dark',
        'light'
    ]),
    left: PropTypes.node,
    right: PropTypes.node
};

Widget.defaultProps = {
    variant: 'dark'
};